import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-col-12 p-d-flex p-flex-wrap p-mt-3" }
const _hoisted_3 = { class: "p-field p-col-6" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-field p-col-6" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-col-12" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-col-12 p-d-flex p-flex-wrap" }
const _hoisted_13 = { class: "p-field p-col-3 p-sm-12 p-md-4" }
const _hoisted_14 = { class: "p-float-label" }
const _hoisted_15 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_16 = { class: "p-col-9 p-sm-12 p-md-8 p-fluid p-formgrid p-grid" }
const _hoisted_17 = { class: "p-field p-col-6 p-sm-12 p-md-6" }
const _hoisted_18 = { class: "p-input-icon-right" }
const _hoisted_19 = { class: "p-float-label" }
const _hoisted_20 = {
  for: "lov",
  class: "kn-material-input-label"
}
const _hoisted_21 = { class: "p-field p-col-6 p-sm-12 p-md-6" }
const _hoisted_22 = { class: "p-float-label" }
const _hoisted_23 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_24 = { class: "p-col-12 p-d-flex p-flex-wrap" }
const _hoisted_25 = { class: "p-field p-col-4 p-sm-12 p-md-4" }
const _hoisted_26 = { class: "p-float-label" }
const _hoisted_27 = {
  for: "default",
  class: "kn-material-input-label"
}
const _hoisted_28 = { class: "p-field p-col-8 p-sm-12 p-md-8" }
const _hoisted_29 = { class: "p-input-icon-right" }
const _hoisted_30 = { class: "p-float-label" }
const _hoisted_31 = {
  for: "lov",
  class: "kn-material-input-label"
}
const _hoisted_32 = { class: "p-field p-col-8 p-sm-12 p-md-8" }
const _hoisted_33 = { class: "p-float-label" }
const _hoisted_34 = {
  for: "defaultFormula",
  class: "kn-material-input-label"
}
const _hoisted_35 = { class: "p-col-12 p-d-flex p-flex-wrap" }
const _hoisted_36 = { class: "p-field p-col-4 p-sm-12 p-md-4" }
const _hoisted_37 = { class: "p-float-label" }
const _hoisted_38 = {
  for: "max",
  class: "kn-material-input-label"
}
const _hoisted_39 = { class: "p-field p-col-6 p-sm-12 p-md-6" }
const _hoisted_40 = { class: "p-input-icon-right" }
const _hoisted_41 = { class: "p-float-label" }
const _hoisted_42 = {
  for: "lov",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_LovsDialog = _resolveComponent("LovsDialog")
  const _component_Card = _resolveComponent("Card")

  return (_ctx.mode.useID)
    ? (_openBlock(), _createBlock(_component_Card, {
        key: 0,
        class: "p-col-12"
      }, {
        content: _withCtx(() => [
          _createVNode("form", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode("div", _hoisted_3, [
                _createVNode("span", _hoisted_4, [
                  _createVNode(_component_InputText, {
                    id: "label",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.mode.label.$invalid && _ctx.v$.mode.label.$dirty
                                }],
                    type: "text",
                    modelValue: _ctx.v$.mode.label.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.mode.label.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.mode.label.$touch())),
                    onInput: _ctx.modeChanged
                  }, null, 8, ["modelValue", "class", "onInput"]),
                  _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.mode.label,
                  additionalTranslateParams: { fieldName: _ctx.$t('common.label') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode("span", _hoisted_7, [
                  _createVNode(_component_InputText, {
                    id: "name",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.mode.name.$invalid && _ctx.v$.mode.name.$dirty
                                }],
                    type: "text",
                    modelValue: _ctx.v$.mode.name.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.mode.name.$model = $event)),
                    modelModifiers: { trim: true },
                    onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.mode.name.$touch())),
                    onInput: _ctx.modeChanged
                  }, null, 8, ["modelValue", "class", "onInput"]),
                  _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.mode.name,
                  additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode("span", _hoisted_10, [
                  _createVNode(_component_InputText, {
                    id: "description",
                    class: "kn-material-input",
                    type: "text",
                    modelValue: _ctx.mode.description,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.mode.description = $event)),
                    modelModifiers: { trim: true },
                    onInput: _ctx.modeChanged
                  }, null, 8, ["modelValue", "onInput"]),
                  _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('common.description')), 1)
                ])
              ])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("div", _hoisted_13, [
                _createVNode("span", _hoisted_14, [
                  _createVNode(_component_Dropdown, {
                    id: "type",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.mode.valueSelection.$invalid && _ctx.v$.mode.valueSelection.$dirty
                                }],
                    modelValue: _ctx.v$.mode.valueSelection.$model,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.mode.valueSelection.$model = $event)),
                    options: _ctx.availableTypes,
                    optionLabel: "name",
                    optionValue: "valueSelection",
                    onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.mode.valueSelection.$touch())),
                    onChange: _ctx.setType
                  }, null, 8, ["modelValue", "options", "class", "onChange"]),
                  _createVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('common.type')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.mode.valueSelection,
                  additionalTranslateParams: { fieldName: _ctx.$t('common.type') }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _withDirectives(_createVNode("div", _hoisted_16, [
                _createVNode("div", _hoisted_17, [
                  _createVNode("span", _hoisted_18, [
                    _createVNode("span", _hoisted_19, [
                      _createVNode(_component_InputText, {
                        id: "lov",
                        modelValue: _ctx.mode.typeLov.name,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.mode.typeLov.name = $event)),
                        class: "kn-material-input",
                        type: "text",
                        disabled: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.lov')) + " * ", 1)
                    ]),
                    _createVNode("i", {
                      class: "pi pi-search input-buton",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showLovsDialog('type')))
                    })
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.mode.typeLov,
                    additionalTranslateParams: { fieldName: _ctx.$t('managers.driversManagement.useModes.lov') },
                    specificTranslateKeys: { required_lovId_for_lov: 'common.validation.required' }
                  }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
                ]),
                _createVNode("div", _hoisted_21, [
                  _createVNode("span", _hoisted_22, [
                    _createVNode(_component_Dropdown, {
                      id: "type",
                      class: ["kn-material-input", {
                                        'p-invalid': _ctx.v$.mode.selectionType.$invalid && _ctx.v$.mode.selectionType.$dirty
                                    }],
                      modelValue: _ctx.v$.mode.selectionType.$model,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.mode.selectionType.$model = $event)),
                      options: _ctx.selectionTypes,
                      optionLabel: "VALUE_NM",
                      optionValue: "VALUE_CD",
                      onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.mode.selectionType.$touch())),
                      onChange: _ctx.modeChanged
                    }, null, 8, ["modelValue", "options", "class", "onChange"]),
                    _createVNode("label", _hoisted_23, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.modality')) + " * ", 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.mode.selectionType,
                    additionalTranslateParams: { fieldName: _ctx.$t('managers.driversManagement.useModes.modality') },
                    specificTranslateKeys: { required_type_for_lov: 'common.validation.required' }
                  }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
                ])
              ], 512), [
                [_vShow, _ctx.mode.valueSelection === 'lov']
              ])
            ]),
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _createVNode("span", _hoisted_26, [
                  _createVNode(_component_Dropdown, {
                    id: "default",
                    class: "kn-material-input",
                    modelValue: _ctx.selectedDefault,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectedDefault = $event)),
                    options: _ctx.defaults,
                    optionLabel: "name",
                    optionValue: "label",
                    onChange: _ctx.setDefault
                  }, null, 8, ["modelValue", "options", "onChange"]),
                  _createVNode("label", _hoisted_27, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.defaultValue')) + " * ", 1)
                ])
              ]),
              _withDirectives(_createVNode("div", _hoisted_28, [
                _createVNode("span", _hoisted_29, [
                  _createVNode("span", _hoisted_30, [
                    _createVNode(_component_InputText, {
                      id: "lov",
                      modelValue: _ctx.mode.defLov.name,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.mode.defLov.name = $event)),
                      class: "kn-material-input",
                      type: "text",
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_31, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.lov')) + " * ", 1)
                  ]),
                  _createVNode("i", {
                    class: "pi pi-search input-buton",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showLovsDialog('default')))
                  })
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.mode.defLov,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.driversManagement.useModes.lov') },
                  specificTranslateKeys: { required_lov_for_default: 'common.validation.required' }
                }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
              ], 512), [
                [_vShow, _ctx.selectedDefault === 'lov']
              ]),
              _withDirectives(_createVNode("div", _hoisted_32, [
                _createVNode("span", _hoisted_33, [
                  _createVNode(_component_Dropdown, {
                    id: "defaultFormula",
                    class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.mode.defaultFormula.$invalid && _ctx.v$.mode.defaultFormula.$dirty
                                }],
                    modelValue: _ctx.v$.mode.defaultFormula.$model,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.v$.mode.defaultFormula.$model = $event)),
                    options: _ctx.useModeDescriptor.defaultFormula,
                    optionLabel: "name",
                    optionValue: "f_value",
                    onBlur: _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.mode.defaultFormula.$touch())),
                    onChange: _ctx.modeChanged
                  }, null, 8, ["modelValue", "options", "class", "onChange"]),
                  _createVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.selectDefaultFormula')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.mode.defaultFormula,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.driversManagement.useModes.selectDefaultFormula') },
                  specificTranslateKeys: { required_for_pick_up: 'common.validation.required' }
                }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
              ], 512), [
                [_vShow, _ctx.selectedDefault === 'pickUp']
              ])
            ]),
            _createVNode("div", _hoisted_35, [
              _withDirectives(_createVNode("div", _hoisted_36, [
                _createVNode("span", _hoisted_37, [
                  _createVNode(_component_Dropdown, {
                    id: "max",
                    class: "kn-material-input",
                    modelValue: _ctx.selectedMax,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.selectedMax = $event)),
                    options: _ctx.useModeDescriptor.maxValues,
                    optionLabel: "name",
                    optionValue: "label",
                    onChange: _ctx.setMax
                  }, null, 8, ["modelValue", "options", "onChange"]),
                  _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.maxValue')) + " * ", 1)
                ])
              ], 512), [
                [_vShow, _ctx.isDate]
              ]),
              _withDirectives(_createVNode("div", _hoisted_39, [
                _createVNode("span", _hoisted_40, [
                  _createVNode("span", _hoisted_41, [
                    _createVNode(_component_InputText, {
                      id: "lov",
                      modelValue: _ctx.mode.maxLov.name,
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.mode.maxLov.name = $event)),
                      class: "kn-material-input",
                      type: "text",
                      disabled: ""
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('managers.driversManagement.useModes.lov')) + " * ", 1)
                  ]),
                  _createVNode("i", {
                    class: "pi pi-search input-buton",
                    onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.showLovsDialog('max')))
                  })
                ]),
                _createVNode(_component_KnValidationMessages, {
                  class: "p-mt-1",
                  vComp: _ctx.v$.mode.maxLov,
                  additionalTranslateParams: { fieldName: _ctx.$t('managers.driversManagement.useModes.lov') },
                  specificTranslateKeys: { required_lov_for_max: 'common.validation.required' }
                }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
              ], 512), [
                [_vShow, _ctx.selectedMax === 'lov']
              ])
            ])
          ]),
          _createVNode(_component_LovsDialog, {
            dialogVisible: _ctx.dialogVisiable,
            lovs: _ctx.lovs,
            selectedLovProp: _ctx.lov,
            onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.dialogVisiable = false)),
            onApply: _ctx.applyLov
          }, null, 8, ["dialogVisible", "lovs", "selectedLovProp", "onApply"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}